/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { queryOptions, useQuery, useSuspenseQuery } from '@tanstack/react-query'
import type {
	UseQueryOptions,
	UseQueryResult,
	UseSuspenseQueryOptions,
	UseSuspenseQueryResult,
} from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { organisationAnalyticsRows } from '../../axios/organisationAnalyticsRows'
import type {
	OrganisationAnalyticsRowsError,
	OrganisationAnalyticsRowsQueryParams,
	OrganisationAnalyticsRowsResponse,
} from '../../types/OrganisationAnalyticsRows'

export const organisationAnalyticsRowsQueryKey = (params?: OrganisationAnalyticsRowsQueryParams) =>
	[{ url: '/analytics/overview/rows' }, ...(params ? [params] : [])] as const

export type OrganisationAnalyticsRowsQueryKey = ReturnType<typeof organisationAnalyticsRowsQueryKey>

/** @see backend/nexus/modules/Analytics/Http/Controllers/OrganisationAnalyticsController.php OrganisationAnalyticsController::rows */
export function organisationAnalyticsRowsQueryOptions(
	params?: OrganisationAnalyticsRowsQueryParams,
	config?: AxiosRequestConfig,
) {
	return queryOptions<
		OrganisationAnalyticsRowsResponse,
		AxiosError<OrganisationAnalyticsRowsError>,
		OrganisationAnalyticsRowsResponse,
		OrganisationAnalyticsRowsQueryKey
	>({
		queryKey: organisationAnalyticsRowsQueryKey(params),
		queryFn: ({ signal }) => organisationAnalyticsRows(params, { signal, ...config }).then(res => res.data),
	})
}

/** @see backend/nexus/modules/Analytics/Http/Controllers/OrganisationAnalyticsController.php OrganisationAnalyticsController::rows */
export function useOrganisationAnalyticsRows<TSelectData = OrganisationAnalyticsRowsResponse>(
	params?: OrganisationAnalyticsRowsQueryParams,
	options?:
		& Partial<
			Omit<
				UseQueryOptions<
					OrganisationAnalyticsRowsResponse,
					AxiosError<OrganisationAnalyticsRowsError>,
					TSelectData,
					OrganisationAnalyticsRowsQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseQueryResult<TSelectData, AxiosError<OrganisationAnalyticsRowsError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useQuery({
		...organisationAnalyticsRowsQueryOptions(params),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}

/** @see backend/nexus/modules/Analytics/Http/Controllers/OrganisationAnalyticsController.php OrganisationAnalyticsController::rows */
export function useOrganisationAnalyticsRowsSuspense<TSelectData = OrganisationAnalyticsRowsResponse>(
	params?: OrganisationAnalyticsRowsQueryParams,
	options?:
		& Partial<
			Omit<
				UseSuspenseQueryOptions<
					OrganisationAnalyticsRowsResponse,
					AxiosError<OrganisationAnalyticsRowsError>,
					TSelectData,
					OrganisationAnalyticsRowsQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseSuspenseQueryResult<TSelectData, AxiosError<OrganisationAnalyticsRowsError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useSuspenseQuery({
		...organisationAnalyticsRowsQueryOptions(params),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}
